import jwt from "jsonwebtoken";
import * as types from "./actionTypes";
import API from "../../services/UserService";
import {JWT_PUBLIC_KEY} from "../../components/common/Const";
import {apiCallError, beginApiCall} from "./apiStatusActions";
import { getStoredAuthToken, removeAuthToken } from "../../services/authTokenStorage";

const SUPPORTED_MANAGEMENT_ROLES = ["ADMIN", "OPERATOR", "TEACHER"];

function normalizeRole(value) {
  if (!value) return null;
  const normalized = String(value).toUpperCase();
  return SUPPORTED_MANAGEMENT_ROLES.includes(normalized) ? normalized : null;
}

function normalizeAuthUser(decoded = {}) {
  const role = normalizeRole(decoded.role) || (
    Array.isArray(decoded.roles) && decoded.roles.length === 1
      ? normalizeRole(decoded.roles[0])
      : null
  );

  return {
    id: decoded.id,
    email: decoded.email || decoded.id,
    role,
    teacherId: decoded.teacherId || null,
  };
}

export function signInSuccess(user) {
  return { type: types.SIGN_IN_SUCCESS, user };
}

export function signIn(userCredentials) {
  // eslint-disable-next-line no-unused-vars
  return (dispatch, getState) => {
    dispatch(beginApiCall('signIn'));
    return API.signIn(userCredentials)
      .then((userLoggedIn) => {
        dispatch(signInSuccess(userLoggedIn));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function signInWithGoogle(googleToken) {
  return (dispatch) => {
    dispatch(beginApiCall("signInWithGoogle"));
    return API.signInWithGoogle(googleToken)
      .then((userLoggedIn) => {
        dispatch(signInSuccess(userLoggedIn));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function signOut() {
  removeAuthToken();
  return { type: types.SIGN_OUT };
}

export function checkToken() {
  return (dispatch) => {
    const token = getStoredAuthToken();
    if (token) {
      const secret = JWT_PUBLIC_KEY;
      jwt.verify(token, secret, {algorithms: ['RS256']}, (err, decoded) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.log('token error', err);
          dispatch(signOut());
        }

        if (decoded) {
          // console.log('token found and verified', decoded);
          dispatch(signInSuccess(normalizeAuthUser(decoded)));
        }
      });
    }
  };
}
